import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, firstValueFrom, map, Observable, tap, throwError } from 'rxjs';
import { AuthSender } from '../models/auth-sender.model';
import { CaptchaSender } from '../models/captcha-sender.model';
import { LogoutSender } from '../models/logout-sender.model';
import { StorageService } from 'core-tsi';
import { urlAuth, urlErp } from '../../shared/utils/general/url';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private http = inject(HttpClient)

  validaCaptcha(sender: CaptchaSender) {
    return this.http.post(`${urlAuth}/usuario/auth-captcha`, sender)
  }

  auth(sender: AuthSender) {
    return this.http.post(`${urlAuth}/usuario/auth`, sender, { observe: 'response' }).pipe(
      tap((resp: HttpResponse<any>) => {
        if (resp.status == 200 && resp.body != null) {
          StorageService.setAll(resp.body);
        }
      }),
      catchError(error => throwError(() => error))
    )
  }

  logout(sender: LogoutSender): Observable<any> {
    const params = new HttpParams()
      .set("coduser", sender.coduser)
      .set("id", sender.id)
    return this.http.put(`${urlErp}/usuario/${sender.id_cia}/logout/v2`, null, { params })
  }

  generateClave(sender: AuthSender): Observable<any> {
    return this.http.post(`${urlErp}/usuario/generar-clave`, sender)
  }

  renovateClave(sender: AuthSender): Observable<any> {
    return this.http.put(`${urlAuth}/usuario/renovar-clave`, sender)
  }

  getGlosaByCompany(cia: number, item: string): Promise<any> {
    return firstValueFrom(this.http.get(`${urlErp}/company/${cia}/glosa/${item}`).pipe(
      map((res: any) => {
        let data = JSON.parse(atob(res.glosaFile_text));
        StorageService.setGrilla(data.forms)
      })
    ))
  }

  validaToken(): Observable<any> {
    return this.http.get(`${urlErp}/accesos/valida-token`)
  }
}
